export const parsePercent = (value: number) : string => {

    return value.toFixed(2);
};
